module.exports = __webpack_public_path__ + "img/14_needle_heater_(white).440f702e.svg";